import { checkIsOrderCoupon } from './checkCoupon';
import getCouponDiscount from './getCouponDiscount';

export default function getCouponDiscountAmount({
  amount = 0,
  setupFeeAmount = 0,
  ticketFeesAmount = 0,
  coupon,
  pageId,
  pageTicketTypes = [],
  primary,
  purchase,
}) {
  if (!coupon) return 0;

  /**
   * Prevent coupons from double discounting.
   * Only apply the coupon discount at this level if it is an order level coupon.
   */
  if (!checkIsOrderCoupon(coupon, pageId, pageTicketTypes, primary, purchase)) return 0;

  // The base widens to the setup fee and/or the ticket fees only when the
  // coupon says so; the two flags are independent.
  let amountToBeDiscounted = amount;

  if (setupFeeAmount && coupon.appliesToSetupFee) {
    amountToBeDiscounted += setupFeeAmount;
  }

  if (ticketFeesAmount && coupon.appliesToTicketFees) {
    amountToBeDiscounted += ticketFeesAmount;
  }

  // prevent coupon discount from being applied on 0 amount, causing negative amounts
  if (amountToBeDiscounted === 0) return 0;

  return getCouponDiscount(amountToBeDiscounted, coupon);
}
